import OResourceList from './o-resource-list.vue'

export default OResourceList
